import React from 'react';
import { Button } from 'react-bootstrap';
import { FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import routes from './../../routes/routes';

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate(routes.LOGIN, { replace: true });
  };

  return (
    <Button variant="danger" className="logout-button" onClick={handleLogout}>
      <FaSignOutAlt /> Logout
    </Button>
  );
};

export default Logout;
